// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fulfillment-view__section{background-color:var(--v-primary-base);border-radius:.25rem}.fulfillment-view__section-row{margin:0}.fulfillment-view__section-col{padding:0}.fulfillment-view__section-col .v-list-item__content{padding-top:0}.fulfillment-view__section-label{border-left-color:var(--v-background-darken4);border-left-style:solid;border-left-width:.5rem;border-top-left-radius:.15rem;color:var(--v-background-darken4);background:var(--v-background-base)}", ""]);
// Exports
module.exports = exports;
